<template>
  <h1>Forbidden</h1>
</template>

<script>
export default {
  name: 'Forbidden',
};
</script>
